"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["active", "activeLinkClassName", "activeListItemClassName", "itemClassName", "linkClassName", "linkRef", "subNavItems", "tagName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable no-unused-vars */
/* 'subNavItems' pulled out in order not to be spread onto link; it's only used for mobile nav */
var NavItem = function NavItem(_ref) {
  var _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    activeLinkClassName = _ref.activeLinkClassName,
    activeListItemClassName = _ref.activeListItemClassName,
    itemClassName = _ref.itemClassName,
    linkClassName = _ref.linkClassName,
    linkRef = _ref.linkRef,
    subNavItems = _ref.subNavItems,
    _ref$tagName = _ref.tagName,
    TagName = _ref$tagName === void 0 ? 'a' : _ref$tagName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: (0, _classnames["default"])(itemClassName, _defineProperty({}, activeListItemClassName, active))
  }, /*#__PURE__*/_react["default"].createElement(TagName, _extends({
    "aria-current": active ? 'location' : null,
    className: (0, _classnames["default"])(linkClassName, _defineProperty({}, activeLinkClassName, active)),
    ref: linkRef
  }, otherProps)));
};
NavItem.propTypes = process.env.NODE_ENV !== "production" ? {
  active: _propTypes["default"].bool,
  activeLinkClassName: _propTypes["default"].string,
  itemClassName: _propTypes["default"].string,
  linkClassName: _propTypes["default"].string,
  linkRef: _propTypes["default"].object,
  subNavItems: _propTypes["default"].array,
  tagName: _propTypes["default"].any
} : {};
var _default = exports["default"] = NavItem;